import { Slide } from '@features/powerpoint';
import { page } from './components/page';

const TOTAL_PAGES = 2;

export const calculationsSlides = (): Slide[] =>
  Array.from({ length: TOTAL_PAGES }, (_, pageIndex): Slide => page(pageIndex));
